var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showButton),expression:"showButton"}],staticClass:"to-top-container",on:{"click":_vm.scrollToTop}},[_c('van-icon',{staticClass:"icon",attrs:{"name":"back-top"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }